import { SvgIcon } from '@material-ui/core';
import React, { CSSProperties } from 'react';
import ic_addProjects from './icons/ic_addProject.png';
import ic_arrow_down_blue from './icons/ic_arrow_down_blue.svg';
import ic_arrow_down_white from './icons/ic_arrow_down_white.png';
import ic_arrow_next_blue from './icons/ic_arrow_next_blue.svg';
import ic_arrow_next_white from './icons/ic_arrow_next_white.svg';
import ic_arrow_right from './icons/ic_arrow_right.svg';
import ic_arrow_right_thin from './icons/ic_arrow_right_thin.svg';
import ic_check from './icons/ic_check.svg';
import ic_checkbox_checked from './icons/ic_checkbox_checked.svg';
import ic_checkbox_rect from './icons/ic_checkbox_rect.svg';
import ic_checkbox_rect_checked from './icons/ic_checkbox_rect_checked.svg';
import ic_circle_arrow_down_blue from './icons/ic_circle_arrow_down_blue.svg';
import ic_circle_arrow_up_orange from './icons/ic_circle_arrow_up_orange.png';
import ic_close from './icons/ic_close.svg';
import ic_close_white from './icons/ic_close_white.svg';
import ic_cross_white from './icons/ic_cross_white.svg';
import ic_delete from './icons/ic_delete.svg';
import ic_devis from './icons/ic_devis.svg';
import ic_download_file from './icons/ic_download_file.svg';
import ic_edit_orange from './icons/ic_edit_orange.svg';
import ic_edit_white from './icons/ic_edit_white.svg';
import ic_export from './icons/ic_export.svg';
import ic_import from './icons/ic_import.svg';
import ic_home from './icons/ic_home.svg';
import ic_laptop from './icons/ic_laptop.svg';
import ic_load from './icons/ic_load.svg';
import ic_projects from './icons/ic_projects.svg';
import ic_radio_checked from './icons/ic_radio_checked.svg';
import ic_radio_normal from './icons/ic_radio_normal.svg';
import ic_save from './icons/ic_save.svg';
import ic_save_white from './icons/ic_save_white.svg';
import ic_search from './icons/ic_search.svg';
import ic_search_black from './icons/ic_search_black.svg';
import ic_selected_blue from './icons/ic_selected_blue.svg';
import ic_selected_white from './icons/ic_selected_white.svg';
import ic_user from './icons/ic_user.svg';
import ic_user_advice from './icons/ic_user_advice.svg';

import ic_rename from './icons/ic_rename.svg';
import ic_rename_white from './icons/ic_rename_white.svg';

import ic_cross_black from './icons/ic_cross_black.svg';
import ic_search_product from './icons/ic_search_product.svg';
import ic_search_product_selected from './icons/ic_search_product_selected.svg';

import img_logo from './logos/logo.svg';

import img_produit_default from './images/img_produit_default.svg';

import img_plan_onboarding_0 from './images/img_plan_onboarding_0.png';
import img_plan_onboarding_1 from './images/img_plan_onboarding_1.png';
import img_plan_onboarding_2 from './images/img_plan_onboarding_2.png';
import img_plan_onboarding_3 from './images/img_plan_onboarding_3.png';

import ic_plan_onboarding_0 from './icons/ic_plan_onboarding_0.svg';
import ic_plan_onboarding_1 from './icons/ic_plan_onboarding_1.svg';
import ic_plan_onboarding_2 from './icons/ic_plan_onboarding_2.svg';
import ic_plan_onboarding_3 from './icons/ic_plan_onboarding_3.svg';

import ic_tutorial_bottom_arrow_white from './icons/ic_tutorial_bottom_arrow_white.svg';
import ic_tutorial_left_arrow_white from './icons/ic_tutorial_left_arrow_white.svg';
import ic_tutorial_right_arrow_white from './icons/ic_tutorial_right_arrow_white.svg';
import ic_tutorial_top_arrow_white from './icons/ic_tutorial_top_arrow_white.svg';

import { ReactComponent as logoRecommendedChoice } from './logos/logo_recommended_choice.svg';

import ic_help from './icons/ic_help.svg';
import ic_minus from './icons/ic_minus.svg';
import ic_plus from './icons/ic_plus.svg';
import img_produit_recommened from './images/img_produit_recommened.svg';

import ic_rect_empty from './icons/ic_rect_empty.svg';
import ic_rect_fill from './icons/ic_rect_fill.svg';

import ic_exclude_option from './icons/ic_exclude_option.svg';

import ic_calendar from './icons/ic_calendar.svg';
import ic_calendar_dark from './icons/ic_calendar_dark.svg';
import ic_download_pdf from './icons/ic_download_pdf.svg';

import ic_estimation_garantie from './icons/ic_estimation_garantie.png';
import ic_estimation_interlocuteur from './icons/ic_estimation_interlocuteur.png';
import ic_estimation_tva from './icons/ic_estimation_tva.png';
import ic_sol from './icons/ic_sol.svg';
import ic_wall from './icons/ic_wall.svg';
import ic_stairs from './icons/ic_stairs.svg';

import ic_rotatable_room from './icons/ic_rotatable_room.svg';
import ic_arrow_left_blue from './icons/ic_arrow_left_blue.svg';
import ic_rotate_antihoraire from './icons/ic_rotate_antihoraire.svg';
import ic_rotate_horaire from './icons/ic_rotate_horaire.svg';

import ic_quote_poseurs_experts from './icons/ic_poseurs_experts.svg';
import ic_quote_tva from './icons/ic_quote_tva.svg';
import ic_quote_pose_garantie from './icons/ic_quote_pose_garantie.svg';

import img_edit_stair_help from './images/img_edit_stair_help.png';

type IconProps = React.ComponentProps<'img'> & { name?: string };
export const Icon = ({ name, ...rest }: IconProps) => <img {...rest} alt={name} />;

export class Assets {
    // #region IndividualIcons

    public static IconHome = () => Icon({ src: ic_home, name: 'home' });
    public static IconLoad = () => Icon({ src: ic_load, name: 'load' });
    public static IconSave = (classes?: IconProps) => <Icon {...classes} src={ic_save} />;
    public static IconSaveWhite = (classes?: IconProps) => <Icon {...classes} src={ic_save_white} />;

    public static IconDelete = () => Icon({ src: ic_delete, name: 'delete' });
    public static IconUser = () => Icon({ src: ic_user, name: 'user' });
    public static IconUserWhite = () => (
        <SvgIcon>
            <g fill="none" fill-rule="evenodd">
                <g transform="translate(4 8)" fill="#FFF">
                    <circle cx="6" cy="4" r="4" />
                    <path d="M3 9h6a3 3 0 0 1 3 3v4H0v-4a3 3 0 0 1 3-3z" />
                </g>
                <path stroke="#FFF" d="M.5 1.5h19v22H.5z" />
                <g transform="translate(8)">
                    <path
                        d="M4.5.5v2c0 .552-.224 1.052-.586 1.414A1.994 1.994 0 0 1 2.5 4.5a1.994 1.994 0 0 1-1.414-.586A1.994 1.994 0 0 1 .5 2.5v-2h4z"
                        stroke="#FFF"
                        fill="#E5A033"
                    />
                    <circle fill="#FFF" cx="2.5" cy="2.5" r="1" />
                </g>
            </g>
        </SvgIcon>
    );
    public static IconAppointment = () => (
        <SvgIcon viewBox="0 0 32 28">
            <path
                d="M30.49,0a.462.462,0,0,1,.49.429.455.455,0,0,1-.44.426l-.05,0H.49A.462.462,0,0,1,0,.429.455.455,0,0,1,.44,0L.49,0Z"
                transform="translate(0.23 20.991)"
                fill="#E5A033"></path>
            <path
                d="M3.4,23.94A3.22,3.22,0,0,1,0,20.964V6.337A3.22,3.22,0,0,1,3.4,3.36H7.92V1.26A1.36,1.36,0,0,1,9.36,0,1.361,1.361,0,0,1,10.8,1.26v2.1h3.36V1.26A1.361,1.361,0,0,1,15.6,0a1.36,1.36,0,0,1,1.44,1.26v2.1H20.4V1.26a1.453,1.453,0,0,1,2.88,0v2.1H27.8a3.22,3.22,0,0,1,3.4,2.976V20.964a3.22,3.22,0,0,1-3.4,2.976ZM.983,6.337V20.964A2.285,2.285,0,0,0,3.4,23.08H27.8a2.285,2.285,0,0,0,2.418-2.116V6.337A2.285,2.285,0,0,0,27.8,4.22H23.28v.82a1.453,1.453,0,0,1-2.88,0V4.22H17.04v.82A1.36,1.36,0,0,1,15.6,6.3a1.361,1.361,0,0,1-1.44-1.26V4.22H10.8v.82A1.361,1.361,0,0,1,9.36,6.3,1.36,1.36,0,0,1,7.92,5.04V4.22H3.4A2.285,2.285,0,0,0,.983,6.337Zm20.857-.9a.437.437,0,0,0,.457-.4V1.26a.461.461,0,0,0-.914,0V5.04A.437.437,0,0,0,21.84,5.44Zm-6.24,0a.437.437,0,0,0,.457-.4V1.26a.461.461,0,0,0-.914,0V5.04A.437.437,0,0,0,15.6,5.44Zm-6.24,0a.437.437,0,0,0,.457-.4V1.26a.461.461,0,0,0-.914,0V5.04A.437.437,0,0,0,9.36,5.44ZM21.84,16.6a.464.464,0,0,1-.491-.43.455.455,0,0,1,.441-.428l.05,0h5.04a.465.465,0,0,1,.492.43.455.455,0,0,1-.441.428l-.05,0Zm-8.64,0a.464.464,0,0,1-.491-.43.455.455,0,0,1,.441-.428l.05,0h5.04a.465.465,0,0,1,.492.43.455.455,0,0,1-.441.428l-.05,0Zm-8.88,0a.464.464,0,0,1-.492-.43.455.455,0,0,1,.441-.428l.05,0H9.36a.465.465,0,0,1,.491.43.455.455,0,0,1-.441.428l-.05,0Zm17.52-3.15a.464.464,0,0,1-.491-.43.455.455,0,0,1,.441-.428l.05,0h5.04a.465.465,0,0,1,.492.43.455.455,0,0,1-.441.428l-.05,0Zm-8.64,0a.464.464,0,0,1-.491-.43.455.455,0,0,1,.441-.428l.05,0h5.04a.465.465,0,0,1,.492.43.455.455,0,0,1-.441.428l-.05,0Zm-8.88,0a.464.464,0,0,1-.492-.43.455.455,0,0,1,.441-.428l.05,0H9.36a.465.465,0,0,1,.491.43.455.455,0,0,1-.441.428l-.05,0ZM21.84,10.3a.464.464,0,0,1-.491-.43.455.455,0,0,1,.441-.428l.05,0h5.04a.465.465,0,0,1,.492.43.455.455,0,0,1-.441.428l-.05,0Zm-8.64,0a.464.464,0,0,1-.491-.43.455.455,0,0,1,.441-.428l.05,0h5.04a.465.465,0,0,1,.492.43.455.455,0,0,1-.441.428l-.05,0Zm-8.88,0a.464.464,0,0,1-.492-.43.455.455,0,0,1,.441-.428l.05,0H9.36a.465.465,0,0,1,.491.43.455.455,0,0,1-.441.428l-.05,0Z"
                transform="translate(0 2.1)"></path>
        </SvgIcon>
    );

    public static IconCheck = (props?: IconProps) => Icon({ src: ic_check, name: 'check', ...props });

    public static IconUserAdvice = (props?: IconProps) => <Icon src={ic_user_advice} {...props} />;

    public static IconArrowRight = () => Icon({ src: ic_arrow_right, name: 'arrow right' });
    public static IconArrowRightThin = (props?: IconProps) => <Icon src={ic_arrow_right_thin} {...props} />;

    public static IconArrowPrevious = (props: React.ComponentProps<typeof SvgIcon>) => (
        <SvgIcon
            width={9}
            height={16}
            viewBox="0 0 9 16"
            fill="#1C1A37"
            xmlns="http://www.w3.org/2000/svg"
            transform="scale(-1 1)"
            style={{ width: 9, height: 16 }}
            {...props}>
            <path d="M.383 15.538a.65.65 0 0 0 .865.05l.058-.05 7.382-7.382L1.306.773a.652.652 0 0 0-.974.866l.05.057 6.46 6.46-6.46 6.459a.653.653 0 0 0-.05.866z" />
        </SvgIcon>
    );

    public static IconArrowNextWhite = () => Icon({ src: ic_arrow_next_white, name: 'arrow next' });
    public static IconArrowNextBlue = () => Icon({ src: ic_arrow_next_blue, name: 'arrow next' });

    public static IconRadioNormal = () => Icon({ src: ic_radio_normal, name: 'radio normal' });
    public static IconRadioChecked = () => Icon({ src: ic_radio_checked, name: 'radio checked' });
    public static IconCheckboxChecked = () => Icon({ src: ic_checkbox_checked, name: 'checkbox checked' });

    public static IconEditWhite = (props?: IconProps) => Icon({ src: ic_edit_white, name: 'edit' });

    public static IconEditOrange = (props?: IconProps) => Icon({ src: ic_edit_orange, name: 'edit' });
    public static IconCrossWhite = (props?: IconProps) => Icon({ src: ic_cross_white, name: 'cross' });

    public static IconSearchBlack = (props?: IconProps) => <Icon src={ic_search_black} name={'search'} {...props} />;
    public static IconSearch = (props?: IconProps) => <Icon src={ic_search} name={'ic_search'} {...props} />;

    public static IconClose = (props?: IconProps) => <Icon src={ic_close} {...props} />;

    public static IconCloseWhite = (props?: IconProps) => <Icon {...props} src={ic_close_white} name="close" />;

    public static IconProjects = (props?: IconProps) => Icon({ src: ic_projects, name: 'projects' });

    public static IconAddProjects = (props?: IconProps) => (
        <Icon src={ic_addProjects} name={'add projects'} {...props} />
    );

    public static IconDevis = (props?: IconProps) => <Icon src={ic_devis} name="devis" {...props} />;
    public static IconCircleArrowUpOrange = (props?: IconProps) =>
        Icon({ src: ic_circle_arrow_up_orange, name: 'ic_circle_arrow_up_orange' });

    public static IconCircleArrowDownBlue = (props?: IconProps) =>
        Icon({ src: ic_circle_arrow_down_blue, name: 'ic_circle_arrow_down_blue' });

    public static IconSelectedBlue = (props?: IconProps) => <Icon src={ic_selected_blue} {...props} />;

    public static IconSelectedWhite = (props?: IconProps) =>
        Icon({ src: ic_selected_white, name: 'ic_selected_white' });

    public static IconCheckboxRect = (props?: IconProps) => Icon({ src: ic_checkbox_rect, name: 'ic_checkbox_rect' });

    public static IconCheckboxRectChecked = (props?: IconProps) =>
        Icon({ src: ic_checkbox_rect_checked, name: 'ic_checkbox_rect_checked' });

    public static IconArrowDownBlue = (props?: IconProps) =>
        Icon({ src: ic_arrow_down_blue, name: 'ic_arrow_down_blue' });
    public static IconArrowDownWhite = () => Icon({ src: ic_arrow_down_white });

    public static IconDownloadFile = (props?: IconProps) => Icon({ src: ic_download_file, name: 'ic_download_file' });

    public static IconLaptop = (props?: IconProps) => Icon({ src: ic_laptop, name: 'ic_laptop' });

    //#endregion

    public static LogoRecommendedChoice = logoRecommendedChoice;

    public static Logo = (props?: IconProps) => <Icon {...props} src={img_logo} />;

    public static ImgDefault = (props?: IconProps) => <Icon src={img_produit_default} {...props} />;

    //* FROM V3

    public static IconCrossBlack = (props?: IconProps) => <Icon {...props} src={ic_cross_black} />;
    public static IconEditPen = (props?: IconProps) => <Icon src={ic_rename} {...props} />;
    public static IconEditPenWhite = (props?: IconProps) => <Icon src={ic_rename_white} {...props} />;

    public static IconSearchProduct = (props?: IconProps) => <Icon {...props} src={ic_search_product} />;
    public static IconSearchProductSelected = (props?: IconProps) => (
        <Icon {...props} src={ic_search_product_selected} />
    );

    public static IconTutorialLeftArrowWhite = (props?: IconProps) => (
        <Icon {...props} src={ic_tutorial_left_arrow_white} />
    );
    public static IconTutorialBottomArrowWhite = (props?: IconProps) => (
        <Icon {...props} src={ic_tutorial_bottom_arrow_white} />
    );
    public static IconTutorialRightArrowWhite = (props?: IconProps) => (
        <Icon {...props} src={ic_tutorial_right_arrow_white} />
    );
    public static IconTutorialTopArrowWhite = (props?: IconProps) => (
        <Icon {...props} src={ic_tutorial_top_arrow_white} />
    );

    public static ImgProduitRecommended = (props?: IconProps) => (
        <Icon {...props} src={img_produit_recommened} style={{ position: 'absolute', top: 0, right: 0 }} />
    );
    public static IconHelp = (props?: IconProps) => <Icon {...props} src={ic_help} />;

    public static IconPlus = (props?: IconProps) => <Icon {...props} src={ic_plus} />;
    public static IconMinus = (props?: IconProps) => <Icon {...props} src={ic_minus} />;

    public static IconRectEmpty = (props?: IconProps) => <Icon {...props} src={ic_rect_empty} />;
    public static IconRectFill = (props?: IconProps) => <Icon {...props} src={ic_rect_fill} />;

    public static IconExcludeOption = (props?: IconProps) => <Icon {...props} src={ic_exclude_option} />;

    public static IconSol = (props?: IconProps) => <Icon {...props} src={ic_sol} />;
    public static IconWall = (props?: IconProps) => <Icon {...props} src={ic_wall} />;
    public static IconStairs = (props?: IconProps) => <Icon {...props} src={ic_stairs} />;

    public static IconDownWhite = () => {
        return (
            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1.90918 1.09082L7.00009 6.18173L12.091 1.09082"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
            </svg>
        );
    };

    public static IconDownloadPdf = (props?: IconProps) => <Icon {...props} src={ic_download_pdf} />;
    public static IconCalendar = (props?: IconProps) => <Icon {...props} src={ic_calendar} />;
    public static IconCalendarDark = (props?: IconProps) => <Icon {...props} src={ic_calendar_dark} />;

    public static IconEstimationTva = (props?: IconProps) => <Icon {...props} src={ic_estimation_tva} />;
    public static IconEstimationGarantie = (props?: IconProps) => <Icon {...props} src={ic_estimation_garantie} />;
    public static IconEstimationInterlocuteur = (props?: IconProps) => (
        <Icon {...props} src={ic_estimation_interlocuteur} />
    );

    public static IconQuotePoseursExperts = (props?: IconProps) => <Icon {...props} src={ic_quote_poseurs_experts} />;
    public static IconQuoteTva = (props?: IconProps) => <Icon {...props} src={ic_quote_tva} />;
    public static IconQuotePoseGarantie = (props?: IconProps) => <Icon {...props} src={ic_quote_pose_garantie} />;

    public static IconMoveMapItem = ({ style }: React.SVGAttributes<any>) => {
        return (
            <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={style}>
                <g clipPath="url(#clip0_1410_30602)" fill="#13123A">
                    <path d="M14.0557 2.81598L11.4201 0.18032C11.3006 0.0608423 11.1412 -0.000327352 10.9765 3.03649e-05C10.8087 -0.00157936 10.6458 0.0608423 10.5263 0.18032L7.94503 2.76161C7.70322 3.00342 7.70322 3.39655 7.94503 3.63819L8.27789 3.97105C8.5113 4.20446 8.91874 4.20446 9.15233 3.97105L10.1405 2.98071V6.61994C10.1405 6.63103 10.147 6.64015 10.1489 6.65053C10.1758 6.96764 10.4417 7.21858 10.766 7.21858H11.2364C11.5782 7.21858 11.8592 6.94099 11.8592 6.59919V6.19283C11.8592 6.19104 11.8592 6.18979 11.8592 6.18836V3.03472L12.8477 4.02524C13.0895 4.26706 13.4818 4.26706 13.7234 4.02524L14.0557 3.69274C14.2976 3.45075 14.2976 3.05744 14.0557 2.81598Z" />
                    <path d="M14.0556 18.3078L13.7229 17.9744C13.4895 17.7406 13.0819 17.7406 12.8481 17.9744L11.8596 18.9649V15.8252C11.8596 15.8235 11.8596 15.8224 11.8596 15.8208V15.4144C11.8596 15.0724 11.5784 14.7812 11.237 14.7812H10.7662C10.4423 14.7812 10.1763 15.0386 10.1493 15.3561C10.1474 15.3667 10.1409 15.3828 10.1409 15.3937V19.0193L9.15273 18.029C8.91914 17.7954 8.51081 17.7954 8.27722 18.029L7.94454 18.3618C7.70308 18.6035 7.70344 18.9968 7.94526 19.2386L10.5267 21.8197C10.6432 21.9365 10.7986 22 10.959 22H10.9823C11.1484 22 11.3035 21.9367 11.4201 21.8197L14.0556 19.1842C14.2974 18.9426 14.2974 18.5494 14.0556 18.3078Z" />
                    <path d="M6.58347 10.1403H6.53053H6.17513C6.17388 10.1403 6.17263 10.1403 6.1712 10.1403H3.04654L4.03706 9.15515C4.15385 9.03853 4.21806 8.88543 4.21806 8.71963C4.21806 8.55365 4.15385 8.39929 4.03706 8.28286L3.7042 7.95072C3.46239 7.7089 3.06908 7.70926 2.82762 7.95107L0.191958 10.5866C0.0724804 10.7059 0.00862794 10.8659 0.0118474 11.0301C0.00844908 11.2009 0.0724804 11.3608 0.191958 11.4803L2.77324 14.0618C2.89415 14.1827 3.0528 14.2431 3.21163 14.2431C3.37045 14.2431 3.5291 14.1827 3.65001 14.0618L3.98269 13.7291C4.09948 13.6125 4.16387 13.4567 4.16387 13.2909C4.16387 13.1249 4.09966 12.9675 3.98269 12.8511L2.99252 11.8591H6.60225C6.61316 11.8591 6.63104 11.8564 6.64142 11.8545C6.95871 11.8277 7.21788 11.5653 7.21788 11.2412V10.7701C7.21788 10.4286 6.92527 10.1403 6.58347 10.1403Z" />
                    <path d="M21.807 10.5872L19.1713 7.95187C18.9297 7.71005 18.5364 7.71005 18.2947 7.95187L17.9622 8.28473C17.8455 8.40116 17.7811 8.55695 17.7811 8.72275C17.7811 8.88873 17.8453 9.03897 17.9622 9.15559L18.9526 10.1407H15.8079C15.8063 10.1407 15.805 10.1407 15.8036 10.1407H15.3974C15.0556 10.1407 14.7812 10.4289 14.7812 10.7705V11.2416C14.7812 11.5657 15.03 11.8277 15.3475 11.8547C15.3581 11.8569 15.3658 11.8596 15.3765 11.8596H19.0068L18.0161 12.8513C17.8995 12.9678 17.8351 13.1248 17.8351 13.2903C17.8351 13.4564 17.8993 13.6126 18.0161 13.7292L18.3491 14.062C18.4698 14.1829 18.6285 14.2436 18.7873 14.2436C18.9461 14.2436 19.1046 14.1831 19.2255 14.0622L21.8072 11.4807C21.9263 11.3616 21.9901 11.2016 21.9873 11.0372C21.99 10.8664 21.9261 10.7063 21.807 10.5872Z" />
                    <path d="M11.0008 9.28027C10.0527 9.28027 9.28125 10.0517 9.28125 11C9.28125 11.9481 10.0527 12.7197 11.0008 12.7197C11.9489 12.7197 12.7205 11.9481 12.7205 11C12.7205 10.0517 11.9489 9.28027 11.0008 9.28027Z" />
                </g>
                <defs>
                    <clipPath id="clip0_1410_30602">
                        <rect width="22" height="22" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    };

    public static ErrorIcon = ({ style, attr }: { style?: CSSProperties; attr?: React.SVGAttributes<any> }) => {
        return (
            <svg
                style={style}
                {...attr}
                width="14"
                height="13"
                viewBox="0 0 14 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g fill="#EB5757">
                    <path d="M6.56328 9.07227C6.19629 9.07227 5.88867 9.39454 5.88867 9.779C5.88867 10.1635 6.19629 10.4857 6.56328 10.4857C6.91678 10.4857 7.23789 10.1635 7.2217 9.79596C7.23789 9.39171 6.93297 9.07227 6.56328 9.07227Z" />
                    <path d="M12.8075 11.5772C13.2312 10.8111 13.2339 9.89796 12.8129 9.13468L8.58715 1.468C8.16889 0.696247 7.41333 0.238281 6.56601 0.238281C5.7187 0.238281 4.96313 0.699073 4.54487 1.46518L0.313708 9.14034C-0.10725 9.91209 -0.104552 10.8308 0.321803 11.597C0.742761 12.3546 1.49563 12.8097 2.33754 12.8097H10.7783C11.6229 12.8097 12.3812 12.3489 12.8075 11.5772ZM11.8901 11.0231C11.6553 11.4471 11.2397 11.6987 10.7756 11.6987H2.33485C1.87611 11.6987 1.46325 11.4528 1.23388 11.0372C1.00181 10.616 0.999113 10.1128 1.23118 9.68876L5.46235 2.01643C5.69172 1.59522 6.10188 1.34644 6.56601 1.34644C7.02745 1.34644 7.44031 1.59804 7.66968 2.01926L11.8981 9.69159C12.1248 10.1043 12.1221 10.6019 11.8901 11.0231Z" />
                    <path d="M6.3958 4.11077C6.07468 4.20689 5.875 4.5122 5.875 4.88253C5.89119 5.10586 5.90468 5.33201 5.92087 5.55534C5.96675 6.40625 6.01262 7.2402 6.05849 8.09111C6.07468 8.37946 6.28786 8.58866 6.5631 8.58866C6.83835 8.58866 7.05422 8.36533 7.06771 8.07415C7.06771 7.89888 7.06771 7.73774 7.0839 7.55965C7.11359 7.01405 7.14597 6.46845 7.17565 5.92284C7.19184 5.56948 7.22153 5.21611 7.23772 4.86274C7.23772 4.73553 7.22153 4.62245 7.17565 4.50937C7.03803 4.19275 6.71692 4.03162 6.3958 4.11077Z" />
                </g>
            </svg>
        );
    };

    public static RightArrowBold = ({ style, attr }: { style?: CSSProperties; attr?: React.SVGAttributes<any> }) => {
        return (
            <svg
                style={style}
                {...attr}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="12" fill="#13123A" />
                <path
                    d="M9.81836 15.8182L13.6365 12L9.81836 8.18181"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        );
    };

    public static LockedIcon = (props: React.SVGAttributes<any>) => {
        return (
            <svg {...props} width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2 14.667q-.55 0-.941-.391a1.3 1.3 0 0 1-.392-.942V6.667q0-.55.391-.941.393-.392.942-.392h.667V4q0-1.383.975-2.358A3.22 3.22 0 0 1 6 .667q1.383 0 2.358.975.976.976.975 2.358v1.334H10q.55 0 .942.392t.391.941v6.667q0 .549-.391.942-.392.391-.942.391zm0-1.333h8V6.667H2zm4-2q.55 0 .942-.392A1.28 1.28 0 0 0 7.333 10q0-.55-.391-.941A1.3 1.3 0 0 0 6 8.667q-.551 0-.941.392-.39.393-.393.941 0 .549.393.942.394.394.94.392m-2-6h4V4q0-.833-.583-1.416A1.93 1.93 0 0 0 6 2q-.834 0-1.417.584A1.93 1.93 0 0 0 4 4z"
                    fill="#E5A033"
                />
            </svg>
        );
    };

    public static UnlockedIcon = (props: React.SVGAttributes<any>) => {
        return (
            <svg {...props} width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 13.334V6.667H2v6.667zm0-8a1.333 1.333 0 0 1 1.333 1.333v6.667A1.333 1.333 0 0 1 10 14.667H2a1.334 1.334 0 0 1-1.333-1.333V6.667A1.333 1.333 0 0 1 2 5.334h6V4a2 2 0 0 0-4 0H2.667a3.333 3.333 0 1 1 6.666 0v1.334zm-4 6a1.333 1.333 0 1 1 0-2.667 1.333 1.333 0 0 1 0 2.667"
                    fill="#424448"
                />
            </svg>
        );
    };

    public static ImportIcon = (props?: IconProps) => <Icon {...props} src={ic_import} />;
    public static ExportIcon = (props?: IconProps) => <Icon {...props} src={ic_export} />;

    public static ImgPlanOnboarding0 = (props?: IconProps) => <Icon src={img_plan_onboarding_0} {...props} />;
    public static ImgPlanOnboarding1 = (props?: IconProps) => <Icon src={img_plan_onboarding_1} {...props} />;
    public static ImgPlanOnboarding2 = (props?: IconProps) => <Icon src={img_plan_onboarding_2} {...props} />;
    public static ImgPlanOnboarding3 = (props?: IconProps) => <Icon src={img_plan_onboarding_3} {...props} />;

    public static IcPlanOnboarding0 = (props?: IconProps) => <Icon src={ic_plan_onboarding_0} {...props} />;
    public static IcPlanOnboarding1 = (props?: IconProps) => <Icon src={ic_plan_onboarding_1} {...props} />;
    public static IcPlanOnboarding2 = (props?: IconProps) => <Icon src={ic_plan_onboarding_2} {...props} />;
    public static IcPlanOnboarding3 = (props?: IconProps) => <Icon src={ic_plan_onboarding_3} {...props} />;

    public static IconRotatableRoom = (props?: IconProps) => <Icon {...props} src={ic_rotatable_room} />;
    public static IconArrowLeftBlue = (props?: IconProps) => <Icon {...props} src={ic_arrow_left_blue} />;
    public static IconRotateAntihoraire = (props?: IconProps) => <Icon {...props} src={ic_rotate_antihoraire} />;
    public static IconRotateHoraire = (props?: IconProps) => <Icon {...props} src={ic_rotate_horaire} />;

    public static ImgEditStairsHelp = (props?: IconProps) => <Icon {...props} src={img_edit_stair_help} />;
}
